import React, { useState, useRef } from 'react';

const ThesisLogicDisplay = ({ logic, handleMouseEnter, handleMouseLeave }) => {
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const showTimeoutRef = useRef(null);
    const hideTimeoutRef = useRef(null);
    
    const handleMouseEnterWithDebounce = (dataID, optionNumber, e) => {
        // Clear any pending hide timeout
        if (hideTimeoutRef.current) {
            clearTimeout(hideTimeoutRef.current);
            hideTimeoutRef.current = null;
        }
        
        // Set a delay before showing tooltip to prevent flickering
        if (!isTooltipVisible) {
            showTimeoutRef.current = setTimeout(() => {
                setIsTooltipVisible(true);
                handleMouseEnter(dataID, optionNumber, e);
            }, 150); // 150ms delay before showing
        } else {
            // If tooltip is already visible, update immediately
            handleMouseEnter(dataID, optionNumber, e);
        }
    };
    
    const handleMouseLeaveWithDebounce = () => {
        // Clear any pending show timeout
        if (showTimeoutRef.current) {
            clearTimeout(showTimeoutRef.current);
            showTimeoutRef.current = null;
        }
        
        // Set a delay before hiding tooltip to prevent flickering
        hideTimeoutRef.current = setTimeout(() => {
            setIsTooltipVisible(false);
            handleMouseLeave();
        }, 300); // 300ms delay before hiding
    };
    
   const renderLogic = (logicText) => {
    const pattern = /\(([\w-]+),\s*(\d+)\)/g;
    const parts = [];
    let lastIndex = 0;

    logicText.replace(pattern, (match, dataID, optionNumber, offset) => {
        if (offset > lastIndex) {
            parts.push(
                <React.Fragment key={`text-${lastIndex}`}>
                    {logicText.slice(lastIndex, offset)}
                </React.Fragment>
            ); // Add text before match
        }
        parts.push(
            <span
                key={`${dataID}-${optionNumber}`}
                style={{ 
                    cursor: 'pointer', 
                    color: 'var(--color-highlight)',
                    padding: '2px 4px', // Add padding to create larger hover area
                    margin: '0 1px', // Small margin to separate from adjacent text
                    borderRadius: '3px',
                    transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => handleMouseEnterWithDebounce(dataID, optionNumber, e)}
                onMouseLeave={handleMouseLeaveWithDebounce}
            >
                {match}
            </span>
        );
        lastIndex = offset + match.length;
    });

    if (lastIndex < logicText.length) {
        parts.push(
            <React.Fragment key={`text-end`}>
                {logicText.slice(lastIndex)}
            </React.Fragment>
        ); // Add remaining text
    }

    return parts;
};


    return <>{renderLogic(logic || '')}</>;
};

export default ThesisLogicDisplay;
